import type { TTrajectory, TTrajectoryMeasure, TTrajectoryStation } from '../../types/trajectory';
import type { TFactTrajectoryPoint } from '../model';

function measureValue(measure: TTrajectoryMeasure | undefined | null): number | null {
  if (!measure || typeof measure.value !== 'number' || Number.isNaN(measure.value)) {
    return null;
  }

  return measure.value;
}

export function mapApiStationToFactPoint(station: TTrajectoryStation): TFactTrajectoryPoint {
  const projected = station.location?.[0]?.projected2dPosition;

  return {
    stationId: station.id,
    md: measureValue(station.md?.measuredDepth),
    inc: measureValue(station.incl),
    azi: measureValue(station.azi),
    azMag: measureValue(station.computed?.aziMag) ?? measureValue(station.azi),
    azTrue: measureValue(station.computed?.aziTrue),
    tvd: measureValue(station.tvd?.verticalDepth),
    tvdss: measureValue(station.computed?.tvdss),
    ns: measureValue(station.dispNs),
    we: measureValue(station.dispEw),
    northing: typeof projected?.coordinate1 === 'number' ? projected.coordinate1 : null,
    easting: typeof projected?.coordinate2 === 'number' ? projected.coordinate2 : null,
    closure: measureValue(station.closure),
    closureDirection: measureValue(station.closureDirection),
    vsec: measureValue(station.vertSect),
    ahd: measureValue(station.computed?.ahd),
    dls: measureValue(station.dls),
    rateTurn: measureValue(station.rateTurn),
    rateBuild: measureValue(station.rateBuild),
    mdDelta: measureValue(station.mdDelta),
    tvdDelta: measureValue(station.tvdDelta),
    tfo: measureValue(station.computed?.tfo),
    mtf: measureValue(station.mtf),
    gtf: measureValue(station.gtf),
    comment: station.app?.comment ?? null,
    typeTrajStation: station.typeTrajStation ?? null,
  };
}

export function omitTrajectoryStations(trajectory: TTrajectory): Omit<TTrajectory, 'trajectoryStations'> {
  const { trajectoryStations: _, ...data } = trajectory;

  return data;
}
